var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "id": "board",
      "max-width": "700px",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "primary secondary--text text-h6 font-weight-bold"
  }, [_vm._v(" Board of Trustees ")]), _c('v-card-text', {
    staticClass: "d-flex flex-column pa-4"
  }, [_c('v-sheet', {
    staticClass: "d-flex align-center justify-start"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-calendar")]), _c('p', {
    staticClass: "text-h6 primary--text font-weight-bold mb-0"
  }, [_vm._v("SCHEDULE")])], 1), _vm.boardDate ? _c('p', [_c('br'), _c('span', {
    staticClass: "text-body-2 primary--text"
  }, [_vm._v(" The next board meeting will be held on:")]), _c('br'), _c('span', {
    staticClass: "text-h6 primary--text font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.boardDate))])]) : _c('p', {
    staticClass: "text-body-1 primary--text font-weight-bold"
  }, [_vm._v(" The next board meeting has not yet been scheduled. "), _c('br'), _vm._v(" Please check back soon for further updates. ")])], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "pr-4",
    attrs: {
      "color": "primary",
      "to": "/about/board-of-trustees#members"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-account-tie-woman")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Members")])], 1), _c('v-btn', {
    staticClass: "pr-4",
    attrs: {
      "color": "primary",
      "to": "/about/board-of-trustees#documents"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-document")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Documents")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }